import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { searchAttritionTextState } from '../../redux/employees'

class SearchAttritionField extends Component {

  handleOnKeyUp = () => {
    this.props.search(this.refs.searchInput.value)
    this.props.dispatch(searchAttritionTextState(this.refs.searchInput.value))
    this.props.callback()
  }

  componentDidMount() {
    if(this.props.employees && this.props.employees.previousAttritonSearchText) {
      this.setValue(this.props.employees.previousAttritonSearchText)
    } else {
      this.setValue("")
    }
  }

  setValue(value) {
    ReactDOM.findDOMNode(this.refs.searchInput).value = value
    this.props.search(value)
  }

  render() {
    return (
      <input
        ref='searchInput'
        className='form-control'
        type='text'
        defaultValue={this.props.defaultValue}
        placeholder="Enter Employee details..."
        onKeyUp={this.handleOnKeyUp} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    employees: state.employees
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(SearchAttritionField)


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/TableCustomComponents/SearchAttritionField.js